import * as types from './actionTypes';
import {beginAjaxCall, ajaxCallError} from './ajaxStatusActions';
import projectAPI from '../api/projectApi';

export function loadProjectsSuccess(projects) {
    return {type: types.LOAD_PROJECTS_SUCCESS, projects};
}

export function getAll() {
    return function (dispatch) {
        dispatch(beginAjaxCall());
        return projectAPI.getAll().then(projects => {
            dispatch(loadProjectsSuccess(projects));
        }).catch(error => {
            throw(error);
        });
    };
}

function storeProject(data) {
    return function (dispatch) {
        dispatch(beginAjaxCall());
        return projectAPI.store(data).then(response => {
            if (!response.error) {
                dispatch(storeProjectSuccess(response));
                return response;
            } else {
                dispatch(storeProjectFailure({errors: response.messages}));
                dispatch(ajaxCallError());
            }
        }).catch((error) => {
            dispatch(storeProjectFailure({error: error.text}));
            dispatch(ajaxCallError());
        });
    };
}

function storeProjectSuccess(project) {
    return {type: types.STORE_PROJECT_SUCCESS, project};
}

function storeProjectFailure(response) {
    return {type: types.STORE_PROJECT_FAILURE, errors: response.errors};
}

function getProjectStates() {
    return function (dispatch) {
        return projectAPI.getStates().then(response => {
            dispatch(getProjectStatesSuccess(response));
        }).catch((error) => {
            dispatch(getProjectStatesFailure({error: error.text}));
        });
    };
}

function getProjectStatesSuccess(states) {
    return {type: types.GET_PROJECT_STATES_SUCCESS, states}
}

function getProjectStatesFailure(error) {
    return {type: types.GET_PROJECT_STATES_FAILURE, error}
}

function updateProject(data) {
    return function (dispatch) {
        return projectAPI.update(data).then(response => {
            if (!response.error) {
                dispatch(updateProjectSuccess(response));
                return response;
            } else {
                dispatch(updateProjectFailure({errors: response.messages}));
            }
        }).catch((error) => {
            dispatch(updateProjectFailure({error: error.text}));
        });
    };
}

function updateProjectSuccess(project){
    return {type: types.UPDATE_PROJECT_SUCCESS, project};
}

function updateProjectFailure(error){
    return {type: types.UPDATE_PROJECT_FAILURE, error};
}

export {
    getProjectStates,
    storeProject,
    updateProject
};


/** WEBPACK FOOTER **
 ** ./src/actions/projectAction.js
 **/